import { makeStyles } from '@material-ui/core/styles';
import {
  Step,
  StepContent,
  StepIcon,
  StepLabel,
  Stepper,
} from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { objectKeys } from '../../../../utils/object-keys';
import { BuyProcessUtils } from '../../index';

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: theme.typography.caption.fontSize,
  },
  stepRoot: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  stepEnabled: {
    cursor: 'pointer',
  },
  horizontalStepLabel: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  horizontalLabelContainer: {
    marginTop: theme.spacing(0.5),
  },

  stepper: {
    paddingRight: 0,
    paddingLeft: 0,
    overflowX: 'auto',
  },

  stepperRoot: {
    display: 'flex',
    justifyContent: 'space-between',
    '& > .MuiStepConnector-root': {
      display: 'none',
    },
  },

  horizontalIconContainer: {
    padding: 0,
  },
}));

type Props = {
  setRequestedStep: (step: number) => unknown;
  lastActiveStep: number;
  activeStep: number;
  getStepInfo: (step: number) => { error: boolean };
  steps: Record<string, string>;
  children?: React.ReactNode | React.ReactNodeArray;
};

export function BuyProcessFormStepper(props: Props) {
  const classes = useStyles();
  const isVerticalStepper = BuyProcessUtils.useIsVerticalStepper();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, [props.activeStep]);

  return (
    <Stepper
      classes={{
        ...(!isVerticalStepper && { root: classes.stepperRoot }),
      }}
      className={classes.stepper}
      nonLinear
      activeStep={props.activeStep}
      orientation={isVerticalStepper ? 'vertical' : 'horizontal'}
    >
      {objectKeys(props.steps).map((key, index) => {
        const disabled = index > props.lastActiveStep;
        const enabled = index <= props.lastActiveStep;
        const completed = index < props.lastActiveStep;
        const active = index === props.activeStep;
        const { error } = props.getStepInfo(index);

        return (
          <Step
            className={classNames(classes.stepRoot, {
              [classes.stepEnabled]: enabled,
            })}
            onClick={() => {
              if (disabled) return;
              props.setRequestedStep(index);
            }}
            completed={completed}
            disabled={disabled}
            key={key}
          >
            <StepLabel
              classes={{
                label: classes.label,
                ...(!isVerticalStepper && {
                  root: classes.horizontalStepLabel,
                  labelContainer: classes.horizontalLabelContainer,
                  iconContainer: classes.horizontalIconContainer,
                }),
              }}
              icon={(
                <StepIcon
                  error={error}
                  active={active}
                  completed={completed && !active}
                  icon={index + 1}
                />
              )}
            >
              {props.steps[key]}
            </StepLabel>

            {props.children && <StepContent>{props.children}</StepContent>}
          </Step>
        );
      })}
    </Stepper>
  );
}
